export default __webpack_public_path__ + "locales/sr-Latn-RS/PreparationPortal.json?hash=f5cc9dcf30690089d217de3862725b2b";